import { GlKeysetPagination } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { TAB_NAME } from '~/ci/catalog/constants';
import CiResourcesListItem from './ci_resources_list_item.vue?vue3';
import CiAnalyticsList from './ci_analytics_list.vue?vue3';
export default {
    name: 'CiResourcesList',
    components: {
        CiResourcesListItem,
        CiAnalyticsList,
        GlKeysetPagination
    },
    props: {
        pageInfo: {
            type: Object,
            required: true
        },
        resources: {
            type: Array,
            required: true
        },
        currentTab: {
            type: String,
            required: true
        }
    },
    emits: [
        'on-next-page',
        'on-prev-page'
    ],
    computed: {
        isAnalyticsTab () {
            return this.currentTab === TAB_NAME.analytics;
        }
    }
};
